
/**
 * Module dependencies.
 */

import { isNil } from 'lodash';
import { useEffect, useState } from 'react';
import cookies from 'browser-cookies';

/**
 * `Banner` type.
 */

type Banner = {
  isBannerVisible: boolean;
  onClose: () => void;
};

/**
 * Export `useBanner` hook.
 */

export function useBanner(): Banner {
  const [isBannerVisible, setBannerVisible] = useState<boolean>(false);

  useEffect(() => {
    if (isNil(cookies.get('sessionToken'))) {
      return setBannerVisible(false);
    }

    return setBannerVisible(true);
  }, []);

  return {
    isBannerVisible,
    onClose: () => setBannerVisible(false)
  };
}
